import React from "react";
import { PromoCardNavigation } from "./PromoCardNavigation/PromoCardNavigation";
import PromotionCardImageSide from "./PromotionCardImageSide/PromotionCardImageSide";
import PromotionCardImageTop from "./PromotionCardImageTop/PromotionCardImageTop";

export type PromoType =
	| "PromoImageLeft"
	| "PromoImageRight"
	| "PromoImageTop"
	| "PromoCardNav";

export const PromotionCardToDisplay: React.FC<
	DogsTrust.PromotionCardToDisplayProps
> = ({ promotionType, ...props }) => {
	if (!promotionType) {
		// Adding noise to builds, turn on if needed
		// console.warn("PromotionType: No variant received.");
		return null;
	}
	switch (promotionType) {
		case "PromoImageLeft":
		case "PromoImageRight":
			return (
				<PromotionCardImageSide
					{...props}
					side={promotionType === "PromoImageLeft" ? "left" : "right"}
				/>
			);
		case "PromoImageTop":
			return <PromotionCardImageTop {...props} />;
		case "PromoCardNav":
			return <PromoCardNavigation {...props} />;
		default:
			return null;
	}
};

export default PromotionCardToDisplay;
